import { useSeo } from "@/lib/seo";
import { Reveal } from "@/components/Reveal";
import { PageHeader } from "@/components/Bits";

const SECURITY = [
  "Card data is handled by Stripe — MONOE doesn't store full card numbers or CVV",
  "Hashed passwords plus an optional payment PIN",
  "Payment and POS webhooks are cryptographically signed and verified",
  "Every shared-terminal action is tied to the signed-in employee with granular permissions",
  "Business and franchise data is access-controlled",
];

const About = () => {
  useSeo({
    title: "About",
    description: "MONOE is a local commerce platform that connects you with the businesses around you — discover, order, split, pay, and get rewarded, all in one app.",
    path: "/about",
  });

  return (
    <div>
      <PageHeader
        eyebrow="MONOE Pay LLC"
        title="Local commerce, finally simple."
        intro="MONOE is a local commerce platform that connects you with the businesses around you — discover, order, split, pay, and get rewarded, all in one app."
        testId="about-hero"
      />

      <section className="border-b border-border">
        <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
          <Reveal>
            <h2 className="font-display text-2xl font-bold tracking-tight">Security you can reason about.</h2>
          </Reveal>
          <div className="mt-6 space-y-3">
            {SECURITY.map((s, i) => (
              <Reveal key={s} delay={i * 0.04}>
                <div className="flex items-start gap-3 rounded-lg border border-border bg-card p-4">
                  <span className="mt-0.5 font-mono-ui text-xs text-muted-foreground">0{i + 1}</span>
                  <span className="text-sm leading-relaxed text-muted-foreground">{s}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section>
        <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
          <Reveal>
            <div className="rounded-lg border border-border bg-card p-6">
              <p className="text-sm leading-relaxed text-muted-foreground">
                <span className="font-semibold text-foreground">Important:</span> MONOE Pay LLC is a
                commerce technology provider and is not a bank, credit union, FDIC-insured depository
                institution, or licensed money transmitter. MONOE does not hold customer funds
                directly.
              </p>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default About;
